import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { AlertRegistryResponse } from "app/core/models/alert-registry-response";

@Injectable()
export class EwanService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getAlerts(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<AlertRegistryResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/ewan/events/alerts`, {
      params: params
      }).pipe(
          
          map(res =>  <AlertRegistryResponse>res)
      );
  }











  getConfig(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/config`);
  }









  editConfig(config: any): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/ewan/config`, config);
  }




  
}
